/**
 * @see https://developer.chrome.com/docs/web-platform/page-lifecycle-api#overview_of_page_lifecycle_states_and_events
 */

jQuery(function ($) {
  gsap.registerPlugin(
    ScrollTrigger,
    ScrollSmoother,
    SplitText
  )

  setupGsapDefaults()
  registerCustomEffects()

  // TODO: migliorare per il mobile. Bisognerebbe
  // controllare costantemente se l'utente cambia
  // da touch a cursore (raro, ma è da considerare se vogliamo fare le cose per bene)
  // if (ScrollTrigger.isTouch !== 1) {
  //   ScrollSmoother.create({
  //     smooth: .8,
  //     effects: false, // TODO: test
  //     speed: 1.2,
  //   })

  //   $("#smooth-content").addClass("active")
  // }

  requestAnimationFrame(() => {
    let triggerElements = $("[data-trigger]").toArray()

    triggerElements.forEach((el) => {
      let animationNames = $(el).data("trigger")
  
      // Separa le stringhe alle virgole (rimuovendo eventuali spazi)
      animationNames.split(/\s*,\s*/).forEach((animation => {
        // Se l'animazione esiste
        if (TRIGGERS[animation]) {
          TRIGGERS[animation](el)
        }
      }))
    })

    setTimeout(()=>{
      ScrollTrigger.refresh(true)
    }, 1000)
  })
  
  // Fa refresh di ScrollTrigger dopo 1000ms dal resize per assicurare che non ci siano layout shift che rompono le posizioni di inizio/fine dei trigger
  $(window).on('resize', debounce(() => {
    ScrollTrigger.refresh()
  }, 1000))

  setupCursor()

  function setupCursor() {
    let $cursor = $("#cursor")
    let xCursorSetter = gsap.quickSetter($cursor[0], "x", "px")
    let yCursorSetter = gsap.quickSetter($cursor[0], "y", "px")

    /**
     * Aiuta a controllare se l'evento ricevuto si è originato da un movimento touch.
     * @param e
     * @returns {boolean}
     */
    let isMouseTouch = (e) => {
      // Checks if the event originated from a touch input.
      // (If undefined, ignore the safeguard)
      return (e?.originalEvent?.sourceCapabilities?.firesTouchEvents ?? false) === true
    }

    let initialMouseMove = (e) => {
      if (isMouseTouch(e)) return

      $cursor.addClass("moved")
      $(document).off("mousemove", initialMouseMove)
    }
    // Non usiamo `one()` dato che non è detto che sia il primissimo movimento a settare il ".moved"
    $(document).on("mousemove", initialMouseMove)

    $(document).on("mousemove", (e) => {
      if (isMouseTouch(e)) return

      xCursorSetter(e.clientX)
      yCursorSetter(e.clientY)
    })

    $("a, button, .cta-button")
      .on("mouseover", (e) => {
        if (isMouseTouch(e)) return

        $cursor.addClass("active")
      })
      .on("mouseleave", (e) => {
        if (isMouseTouch(e)) return

        $cursor.removeClass("active")
      })
  }
})

function setupGsapDefaults() {
  gsap.config({
    nullTargetWarn: false,
    force3D: false,
  })

  ScrollTrigger.config({
    ignoreMobileResize: true,
  })
}